import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';

import { useApiContext } from 'context/ApiContext';
import { KEYS } from 'helpers/react-query.config';
import { useGlobalContext } from 'context/GlobalContext';

const useGetAllProjects = () => {
  const { showApiError } = useGlobalContext();
  const { catalog: catalogApi } = useApiContext();
  const { t } = useTranslation('global');

  const { data: projects, isLoading: isProjectsLoading } = useQuery(
    [KEYS.catalog.project.AllProjects],
    () =>
      catalogApi.projects.GetAllProjects({
        enabled: true,
        isExport: true
      }),
    {
      select: (data) => data?.data?.data?.items,
      onError: (error) =>
        showApiError(error, t('errorMessages.allProjects'), 3000),
      refetchOnWindowFocus: false
    }
  );

  return {
    projects,
    isProjectsLoading
  };
};

export default useGetAllProjects;
